import * as Sentry from '@sentry/react'
import {
  dashboard20240730Client,
  DashboardApi20240730
} from '@sequencehq/api/dashboard/v20240730'
import { downloadBlob } from '@sequencehq/utils'
import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'

type UseCreditNotesCsvExport = () => {
  download: {
    available: boolean
    disabled: boolean
    onClick: (
      queryParams: DashboardApi20240730.GetCreditNotesCsvDownload.Params
    ) => void
  }
}

export const useCreditNotesCsvExport: UseCreditNotesCsvExport = () => {
  const { displayPromiseNotification } = useNotifications()

  const downloadCsv = useCallback(
    async (
      queryParams: DashboardApi20240730.GetCreditNotesCsvDownload.Params
    ) => {
      const downloadOperation = async () => {
        const creditNoteCsvRes =
          await dashboard20240730Client.getCreditNotesCsvDownload(queryParams)

        if (!creditNoteCsvRes.data) {
          throw new Error(
            'An error occurred while downloading the credit notes'
          )
        }

        downloadBlob('credit-notes-export.csv')(creditNoteCsvRes.data)
        return creditNoteCsvRes.data
      }

      await displayPromiseNotification(downloadOperation(), {
        loading: 'Preparing download',
        success: 'Download ready',
        error: 'CSV download failed'
      })
    },
    [displayPromiseNotification]
  )

  return {
    download: {
      available: true,
      disabled: false,
      onClick: queryParams => void downloadCsv(queryParams)
    }
  }
}
